"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                ContextMenu_FastTabCollapse: "Collapse",
                ContextMenu_FastTabCollapseAll: "Collapse all",
                ContextMenu_FastTabExpand: "Expand",
                ContextMenu_FastTabExpandAll: "Expand all",
                SectionPage_Collapse: "Collapse FastTab",
                SectionPage_Expand: "Expand FastTab",
            }
        });
        /**
         * A container to use within a $dyn.controls.Section.
         */
        var SectionPage = /** @class */ (function (_super) {
            __extends(SectionPage, _super);
            function SectionPage() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            SectionPage.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                if (!this._parent) {
                    this._parent = this.getParent();
                }
                if (this._parent && this._parent.RegisterSectionPage) {
                    this._parent.RegisterSectionPage(this);
                }
                this.recordTelemetry = function (event) { };
                // Has to be defined within init() because we need the this context for the contextMenu command
                this.Clicked = function (event) {
                    if ($dyn.value(_this.FastTabExpanded) !== SectionPage.FastTabExpandedState.Always) {
                        // click (user action) - save personalization
                        // First save personalization then call expanded changed as persist personalzation will also save the original values for views
                        $dyn.callFunction(_this.PersistPersonalization, _this, ["expanded", !$dyn.value(_this.Expanded)]);
                        $dyn.applyFunction(_this.ExpandedChanged, _this, [!$dyn.value(_this.Expanded)]);
                        _this.recordTelemetry(event);
                    }
                    if ($dyn.ax.personalizationUtil) {
                        $dyn.ax.personalizationUtil.forceUpdateFormPersonalizationData();
                    }
                };
                this.LayoutColumns = $dyn.ui.columnsProperty($dyn.layout.Columns.balanced, this);
                this.Width = $dyn.layout.Size.available;
                this.Height = $dyn.value(this.FastTabExpanded) === "Always" ? $dyn.layout.Size.available : $dyn.layout.Size.content;
            };
            SectionPage.prototype.getTaskGuideParams = function (options) {
                options = _super.prototype.getTaskGuideParams.call(this, options);
                var sectionPageHeader = this.getHeader();
                options.target = sectionPageHeader ? $(sectionPageHeader) : $(this.element);
                return options;
            };
            SectionPage.prototype.getContextMenuOptions = function (targetElement) {
                var options = [];
                if ($(targetElement).hasClass("section-page-header") || (targetElement.parentElement && $(targetElement.parentElement).hasClass("section-page-header"))) {
                    var parentAsSection = this._parent;
                    options = [
                        { Label: $dyn.label("ContextMenu_FastTabCollapseAll"), Command: parentAsSection.CollapseAll, Enabled: parentAsSection.CanCollapseAll() },
                        { Label: $dyn.label("ContextMenu_FastTabExpandAll"), Command: parentAsSection.ExpandAll, Enabled: parentAsSection.CanExpandAll() },
                        { Label: $dyn.label("ContextMenu_FastTabCollapse"), Command: this.Clicked, Enabled: $dyn.value(this.Expanded) },
                        { Label: $dyn.label("ContextMenu_FastTabExpand"), Command: this.Clicked, Enabled: !$dyn.value(this.Expanded) }
                    ];
                }
                options = options.concat(_super.prototype.getContextMenuOptions.call(this, targetElement));
                return options;
            };
            /**
             * The page header.
             */
            SectionPage.prototype.getHeader = function () {
                var sectionPage = $(this.element);
                if (sectionPage.length) {
                    return sectionPage.find(".section-page-header")[0];
                }
            };
            /**
             * @returns if control is available for expando personalization feature
             */
            SectionPage.prototype.isControlAvailableForExpando = function () {
                return true;
            };
            /**
             * @returns expando personalization focus element
             */
            SectionPage.prototype.getExpandoPersonalizationFocusTarget = function () {
                return $(this.getHeader());
            };
            /**
             * The context of the parent element.
             */
            SectionPage.prototype.getParent = function () {
                return $dyn.context(this.element.parentElement);
            };
            /**
             * Handler for keyDown events
             * @param event The keydown event that occurred.
             */
            SectionPage.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            SectionPage.prototype.Activate = function () {
                if ($dyn.value(this.Expanded)) {
                    // If tab is already expanded server code will not execute
                    // Set focus to first focusable control if we found one, otherwise to the header
                    // Using InternalFocusIn with forcefocus to check for crossing save boundary and update the server selected control if needed
                    var focusableControl = $dyn.util.findFirstFocusableControl(this.element);
                    if ($(focusableControl).hasClass("section-page-header")) {
                        var headerControl = $(this.element).find("[data-dyn-role=SectionPageHeader]");
                        focusableControl = headerControl.length > 0 ? headerControl[0] : focusableControl;
                    }
                    this.Root.InternalFocusIn(focusableControl, $dyn.context(this.Root.element).ActiveElement(), true);
                }
                else {
                    // if its not already expanded we just need to call to expandedChange and server will take care of setting focus to first focusable control
                    $dyn.applyFunction(this.ExpandedChanged, this);
                }
            };
            /** @internal */
            SectionPage.prototype.focusCallback = function () {
                // This means that no control was found to focus inside of this container
                // we will set focus to the header element and the container will be the active control.
                var containerHeaderElement = this.getHeader ? this.getHeader() : undefined;
                if (containerHeaderElement) {
                    $dyn.util.focusElement(containerHeaderElement);
                }
            };
            return SectionPage;
        }($dyn.ui.Container));
        controls.SectionPage = SectionPage;
        (function (SectionPage) {
            /**
             * Describes fasttab expanded states
             * @internal
             */
            var FastTabExpandedState;
            (function (FastTabExpandedState) {
                FastTabExpandedState["No"] = "No";
                FastTabExpandedState["Yes"] = "Yes";
                FastTabExpandedState["Auto"] = "Auto";
                FastTabExpandedState["Always"] = "Always";
            })(FastTabExpandedState = SectionPage.FastTabExpandedState || (SectionPage.FastTabExpandedState = {}));
        })(SectionPage = controls.SectionPage || (controls.SectionPage = {}));
        SectionPage.prototype.Label = "";
        SectionPage.prototype.FastTabExpanded = SectionPage.FastTabExpandedState.Auto;
        SectionPage.prototype.ExpandedChanged = function () {
            $dyn.setValue(this, "Expanded", !$dyn.value(this.Expanded));
        };
        $dyn.ui.addObservablePropertiesToPrototype(SectionPage.prototype, {
            Expanded: true
        });
        // tslint:disable:object-literal-sort-keys
        var sectionPageShortcuts = {
            ToggleExpansion: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                Handler: function (evt) {
                    if (evt.target === this.getHeader()) {
                        this.Clicked(evt);
                    }
                    else {
                        return false;
                    }
                },
                RecordTelemetry: false,
                ShowToUser: function (target) {
                    return (target === this.getHeader() && $dyn.value(this.FastTabExpanded) !== SectionPage.FastTabExpandedState.Always);
                },
                Description: function () {
                    return $dyn.value(this.Expanded) ? $dyn.label("SectionPage_Collapse") : $dyn.label("SectionPage_Expand");
                }
            },
            CollapseTab: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.Number0 },
                Handler: function () {
                    if ($dyn.value(this.FastTabExpanded) !== SectionPage.FastTabExpandedState.Always && $dyn.value(this.Expanded)) {
                        // First save personalization then call expanded changed as persist personalzation will also save the original values for views
                        $dyn.callFunction(this.PersistPersonalization, this, ["expanded", !$dyn.value(this.Expanded)]);
                        $dyn.applyFunction(this.ExpandedChanged, this, [!$dyn.value(this.Expanded)]);
                        $dyn.util.focusElement(this.getHeader());
                    }
                },
                ShowToUser: function () {
                    return ($dyn.value(this.FastTabExpanded) !== SectionPage.FastTabExpandedState.Always && $dyn.value(this.Expanded));
                },
                Description: $dyn.label("SectionPage_Collapse")
            }
        };
        SectionPage.prototype.Shortcuts = $dyn.extendPrototype(SectionPage.prototype.Shortcuts, sectionPageShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=SectionPage.js.map
